import {AfterViewInit, Component, EventEmitter, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef, MatSnackBar} from '@angular/material';
import {AbstractControl, FormControl, FormGroup, Validators} from '@angular/forms';
import {ErrorDialogComponent} from '../error-dialog/error-dialog.component';
import {FileUploader, FileUploaderOptions} from 'ng2-file-upload';
import {UserService} from '../../../service/User/user.service';
import {UploadService} from '../../../service/common/upload.service';
import {DefaultThemeComponent} from '../../../component/Common/Theme/default-theme/default-theme.component';
import {ThemeService} from '../../../service/Theme/theme.service';
import {SettingService} from '../../../service/Setting/setting.service';
import {JobService} from '../../../service/Job/job.service';
import {Observable} from "rxjs";
import {map, startWith} from "rxjs/operators";

@Component({
  selector: 'app-input-dialog',
  templateUrl: '../../menu/staff/add-staff-dialog/add-staff-dialog.component.html',
  styleUrls: ['../../menu/staff/add-staff-dialog/add-staff-dialog.component.css']
})
export class AddNewDialogComponent implements OnInit, AfterViewInit {

  public pageLoaded;
  public addStaffForm: FormGroup;
  public jobs;
  public inputData;

  // filter job
  filteredOptions: Observable<string[]>;

  public uploader: FileUploader;
  private uploadPreset;
  private uploadUrl;
  private uploadClouldName;
  public picture;
  public doneProcess;

  // cover picture
  public profileCover;
  public theme: DefaultThemeComponent;

  constructor(private dialog: MatDialogRef<AddNewDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data, private snackBar: MatSnackBar, private settingService: SettingService,
              private uploadService: UploadService, private userService: UserService, private themeService: ThemeService,
              private jobService: JobService) {}

  ngOnInit() {
    // Theme
    this.theme = this.themeService.getComponent();
    this.themeService.themeListener.subscribe((theme) => {
      this.theme = theme;
    });

    this.doneProcess = true;
    this.uploadClouldName = this.uploadService.uploadClouldName;
    this.uploadUrl = this.uploadService.uploadUrl;
    this.uploadPreset = this.uploadService.uploadProfilePreset;

    this.getCoverPicture();

    this.addStaffForm = new FormGroup({
      firstName: new FormControl('', [Validators.required]),
      lastName: new FormControl('', [Validators.required]),
      job: new FormControl('', [Validators.required]),
      proType: new FormControl('', []),
      email: new FormControl('', [Validators.required, Validators.email]),
      password: new FormControl('', [Validators.required]),
      confirmPassword: new FormControl('', []),
    }, {
      validators: [this.MatchPassword]
    });

    this.jobService.getAllJob().subscribe(data => {
      this.jobs = data;

      // filter job search
      this.filteredOptions = this.addStaffForm.controls.job.valueChanges.pipe(
        startWith(''),
        map(value => this._filter(value))
      );

      this.jobs = this.jobs.filter((f) => {
        return f.isDeleted != 'true';
      });
      this.jobs = this.jobs.sort((a, b) => a.label < b.label ? -1 : a.label > b.label ? 1 : 0);
    }, error => {
      console.log(error);
    });

    const uploaderOptions: FileUploaderOptions = {
      url: this.uploadUrl,
      autoUpload: false,
      isHTML5: true,
      removeAfterUpload: true,
      headers: [
        {
          name: 'X-Requested-With',
          value: 'XMLHttpRequest'
        }
      ]
    };

    this.uploader = new FileUploader(uploaderOptions);

    this.uploader.onBuildItemForm = (fileItem, form) => {
      const fileType = fileItem.file.type.split('/')[0];
      form.append('upload_preset', this.uploadPreset);
      form.append('file', fileItem);
      form.append('tags', fileType);
      form.append('public_id', 'profile_' + new Date().getTime());

      fileItem.withCredentials = false;
      this.doneProcess = false;
      return {fileItem, form};
    };

    this.uploader.onCompleteItem = (item, response, status, headers) => {
      const res = JSON.parse(response);

      const getData = this.uploadService.getClouldinaryUrl(res);
      this.picture = getData.mediaTransformUrl;
      this.doneProcess = true;
    };
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.pageLoaded = true;
    }, 1000);
  }

  onClearImage() {
    this.picture = null;
  }

  public hasError = (controlName, errorName: string) => {
    return this.addStaffForm.controls[controlName].hasError(errorName);
  }

  onClose() {
    this.dialog.close(false);
  }

  findJob(label) {
    return this.jobs.find((job) => {
      return job.label.toLowerCase() === label.toLowerCase();
    });
  }

  onAddNewUser(inputData) {
    this.userService.addNewUser(inputData).subscribe(data => {
      this.snackBar.openFromComponent(ErrorDialogComponent, {
        duration: 3000,
        verticalPosition: 'top',
        horizontalPosition: 'end',
        data: 'addUser'
      });
      this.dialog.close();
    }, error => {
      if (error.error.message === 'Email is already taken.') {
        this.snackBar.openFromComponent(ErrorDialogComponent, {
          duration: 3000,
          verticalPosition: 'top',
          horizontalPosition: 'end',
          data: 'emailTaken'
        });
      }
      console.log(error);
    });
  }

  onSubmit() {
    if (this.addStaffForm.valid) {
      const inputData = this.addStaffForm.value;
      inputData.proType = inputData.proType.toLowerCase();
      // inputData.profileUrl = this.picture;
      if (!this.picture) {
        delete inputData.profileUrl;
      }
      delete inputData.confirmPassword;

      const job = this.findJob(inputData.job);
      if (job) {
        inputData.job = job._id;
        if (!this.picture) {
          this.onAddNewUser(inputData);
        } else {
          this.uploader.uploadAll();
          this.inputData = inputData;
        }
      } else {
        this.jobService.addNewJob({label: inputData.job}).subscribe((response: any) => {
          inputData.job = response._id;
          if (!this.picture) {
            this.onAddNewUser(inputData);
          } else {
            this.uploader.uploadAll();
            this.inputData = inputData;
          }
        });
      }
    }
  }

  MatchPassword(AC: AbstractControl) {
    const password = AC.get('password').value;
    const confirmPassword = AC.get('confirmPassword').value;
    if (confirmPassword == '') {
      AC.get('confirmPassword').setErrors( {required: true} );
    } else if (password != confirmPassword) {
      AC.get('confirmPassword').setErrors( {MatchPassword: true} );
    } else {
      AC.get('confirmPassword').setErrors( null );
      return null;
    }
  }

  // cover picture
  getCoverPicture() {
    this.profileCover = './assets/image/logo/default_cover_store.jpg';

    this.settingService.getSetting().subscribe(setting => {
      if (setting[0].contactBackground) {
        this.profileCover = setting[0].contactBackground;
      }
    }, error => {
      console.log(error);
    });
  }

  onFileSelected(event: EventEmitter<File[]>) {
    const file: File = event[0];
    this.viewImageOffline(file);
  }

  viewImageOffline(input) {
    const reader = new FileReader();
    reader.onload = (e: any) => {
      this.picture = e.target.result;
    };
    reader.readAsDataURL(input);
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.jobs.filter(option => option.label.toLowerCase().includes(filterValue));
  }

  // bool
  isAllowCreate() {
    return this.addStaffForm.valid;
  }
}
